<template>
<div class="st-page">
  <Navigation />
  <div class="container" style="padding-top:20px;max-width:1200px;">
    <div class="d-flex align-items-center justify-content-between mb-3 flex-wrap gap-2">
      <div class="d-flex align-items-center gap-3">
        <a href="javascript:void(0)" @click="$router.push('/dashboard')" class="st-back"><i class="mdi mdi-arrow-left"></i></a>
        <h4 class="st-page-title"><i class="mdi mdi-calendar-star me-2"></i>Events</h4>
      </div>
      <button class="btn st-btn-primary btn-sm" @click="openEventForm()">+ New Event</button>
    </div>

    <!-- Event List -->
    <div v-if="!selectedEvent">
      <div class="d-flex gap-2 mb-3">
        <button v-for="s in ['','upcoming','ongoing','completed','cancelled']" :key="s" class="btn btn-sm" :class="statusFilter===s ? 'st-btn-primary' : 'st-btn-outline'" @click="statusFilter=s; loadEvents()" style="font-size:11px;padding:4px 12px;">{{ s || 'All' }}</button>
      </div>
      <div v-if="evtLoading" class="st-spinner"><span class="spinner-border"></span></div>
      <div v-else-if="events.length === 0" style="text-align:center;padding:40px;color:#4A6A8A;">No events yet</div>
      <div v-for="e in events" :key="e.id" class="ev-card" @click="openEvent(e)">
        <div class="d-flex justify-content-between align-items-start flex-wrap gap-2">
          <div>
            <div class="ev-name">{{ e.name }}</div>
            <div class="ev-meta">📍 {{ e.venue || 'TBD' }} · 📅 {{ e.event_date }} <span v-if="e.start_time">· {{ e.start_time?.substring(0,5) }}</span></div>
          </div>
          <div style="text-align:right;">
            <span class="ev-status" :class="'ev-'+e.status">{{ e.status }}</span>
            <div v-if="e.price_per_student > 0" style="font-size:12px;color:#10B981;font-weight:600;margin-top:4px;">KSh {{ Number(e.price_per_student).toLocaleString() }}/student</div>
          </div>
        </div>
        <div class="ev-stats">
          <span>👥 {{ e.attended || 0 }} attended</span>
          <span>💰 KSh {{ Number(e.revenue || 0).toLocaleString() }} revenue</span>
          <span>📤 KSh {{ Number(e.expenses || 0).toLocaleString() }} expenses</span>
          <span :style="{color: (e.revenue - e.expenses) >= 0 ? '#10B981' : '#EF4444', fontWeight:600}">P&L: KSh {{ Number((e.revenue||0) - (e.expenses||0)).toLocaleString() }}</span>
        </div>
      </div>
    </div>

    <!-- Event Detail -->
    <div v-if="selectedEvent">
      <button class="btn st-btn-outline btn-sm mb-3" @click="selectedEvent=null; detail=null;">← Back to Events</button>

      <div class="st-section mb-3" style="padding:16px;">
        <div class="d-flex justify-content-between align-items-start flex-wrap gap-2 mb-2">
          <div>
            <h5 style="color:#E8EDF4;margin:0;font-size:18px;">{{ selectedEvent.name }}</h5>
            <div style="color:#8BA4C4;font-size:13px;">📍 {{ selectedEvent.venue || 'TBD' }} · 📅 {{ selectedEvent.event_date }} · {{ selectedEvent.start_time?.substring(0,5) || '' }}–{{ selectedEvent.end_time?.substring(0,5) || '' }}</div>
            <div v-if="selectedEvent.description" style="color:#4A6A8A;font-size:12px;margin-top:4px;">{{ selectedEvent.description }}</div>
          </div>
          <div class="d-flex gap-2">
            <select class="st-input" v-model="selectedEvent.status" @change="updateEventStatus" style="width:120px;padding:5px 8px;font-size:11px;">
              <option value="upcoming">Upcoming</option><option value="ongoing">Ongoing</option><option value="completed">Completed</option><option value="cancelled">Cancelled</option>
            </select>
            <button class="btn st-btn-outline btn-sm" @click="openEventForm(selectedEvent)">✏️</button>
          </div>
        </div>
        <!-- P&L Summary -->
        <div v-if="detail" class="ev-pl-row">
          <div class="ev-pl-box"><div class="ev-pl-label">Revenue</div><div class="ev-pl-value" style="color:#10B981;">KSh {{ Number(detail.revenue||0).toLocaleString() }}</div></div>
          <div class="ev-pl-box"><div class="ev-pl-label">Expenses</div><div class="ev-pl-value" style="color:#EF4444;">KSh {{ Number(detail.total_expenses||0).toLocaleString() }}</div></div>
          <div class="ev-pl-box"><div class="ev-pl-label">Profit/Loss</div><div class="ev-pl-value" :style="{color: detail.profit >= 0 ? '#10B981' : '#EF4444'}">KSh {{ Number(detail.profit||0).toLocaleString() }}</div></div>
          <div class="ev-pl-box"><div class="ev-pl-label">Attended</div><div class="ev-pl-value" style="color:#4FC3F7;">{{ (detail.attendance||[]).length }}</div></div>
          <div class="ev-pl-box"><div class="ev-pl-label">Paid</div><div class="ev-pl-value" style="color:#F59E0B;">{{ (detail.payments||[]).length }}</div></div>
        </div>
      </div>

      <!-- Detail Tabs -->
      <div class="la-tabs">
        <button class="la-tab" :class="{active:dtab==='attendance'}" @click="dtab='attendance'">👥 Attendance</button>
        <button class="la-tab" :class="{active:dtab==='payments'}" @click="dtab='payments'">💰 Payments</button>
        <button class="la-tab" :class="{active:dtab==='expenses'}" @click="dtab='expenses'">📤 Expenses</button>
        <button class="la-tab" :class="{active:dtab==='prizes'}" @click="dtab='prizes'">🏆 Prizes</button>
      </div>

      <!-- Attendance -->
      <div v-if="dtab==='attendance'" class="st-section" style="padding:14px;">
        <div class="d-flex gap-2 mb-3 align-items-end">
          <input class="st-input" v-model="attSearch" placeholder="Search student..." style="width:200px;" @input="searchStudentsForEvent" />
          <template v-if="attSearchResults.length"><button class="btn st-btn-outline btn-sm" v-for="s in attSearchResults.slice(0,5)" :key="s.id" @click="markEventAttendance(s)" style="padding:3px 10px;font-size:11px;">{{ s.name }}</button></template>
        </div>
        <table v-if="detail?.attendance?.length" class="la-table">
          <thead><tr><th>Student</th><th>Admission</th><th>Checked In</th></tr></thead>
          <tbody><tr v-for="a in detail.attendance" :key="a.id"><td>{{ a.student_name }}</td><td>{{ a.admission_no }}</td><td>{{ a.checked_in_at }}</td></tr></tbody>
        </table>
        <div v-else style="color:#4A6A8A;text-align:center;padding:20px;">No attendance recorded yet</div>
      </div>

      <!-- Payments -->
      <div v-if="dtab==='payments'" class="st-section" style="padding:14px;">
        <div class="d-flex gap-2 mb-3 align-items-end">
          <input class="st-input" v-model="paySearch" placeholder="Search student..." style="width:160px;" @input="searchStudentsForEvent" />
          <select class="st-input" v-model="payMethod" style="width:100px;padding:7px;"><option value="cash">Cash</option><option value="mpesa">M-Pesa</option><option value="wallet">Wallet</option></select>
          <input class="st-input" v-model.number="payAmount" type="number" :placeholder="'KSh '+(selectedEvent.price_per_student||0)" style="width:100px;" />
          <div v-if="paySearchResults.length" class="d-flex gap-1 flex-wrap">
            <button v-for="s in paySearchResults.slice(0,5)" :key="s.id" class="btn st-btn-outline btn-sm" @click="recordPayment(s)" style="padding:3px 8px;font-size:10px;">{{ s.name }}</button>
          </div>
        </div>
        <table v-if="detail?.payments?.length" class="la-table">
          <thead><tr><th>Student</th><th>Amount</th><th>Method</th><th>Ref</th><th>Date</th></tr></thead>
          <tbody><tr v-for="p in detail.payments" :key="p.id"><td>{{ p.student_name }}</td><td style="font-weight:600;color:#10B981;">KSh {{ Number(p.amount).toLocaleString() }}</td><td>{{ p.payment_method }}</td><td>{{ p.transaction_ref || '—' }}</td><td>{{ p.paid_at }}</td></tr></tbody>
        </table>
      </div>

      <!-- Expenses -->
      <div v-if="dtab==='expenses'" class="st-section" style="padding:14px;">
        <div class="d-flex gap-2 mb-3 flex-wrap align-items-end">
          <select class="st-input" v-model="expForm.category" style="width:120px;padding:7px;"><option v-for="c in expCategories" :key="c" :value="c">{{ c }}</option></select>
          <input class="st-input" v-model="expForm.description" placeholder="Description" style="width:160px;" />
          <input class="st-input" v-model.number="expForm.amount" type="number" placeholder="Amount" style="width:100px;" />
          <input class="st-input" v-model="expForm.paidTo" placeholder="Paid to" style="width:120px;" />
          <button class="btn st-btn-primary btn-sm" @click="addExpense" :disabled="!expForm.amount">+ Add</button>
        </div>
        <table v-if="detail?.expenses?.length" class="la-table">
          <thead><tr><th>Category</th><th>Description</th><th>Amount</th><th>Paid To</th><th>By</th><th></th></tr></thead>
          <tbody>
            <tr v-for="e in detail.expenses" :key="e.id">
              <td style="text-transform:capitalize;">{{ e.category }}</td><td>{{ e.description }}</td>
              <td style="font-weight:600;color:#EF4444;">KSh {{ Number(e.amount).toLocaleString() }}</td>
              <td>{{ e.paid_to || '—' }}</td><td>{{ e.recorded_by_name }}</td>
              <td><button class="btn st-btn-outline btn-sm" style="padding:1px 6px;font-size:10px;color:#EF4444;" @click="deleteExpense(e)">🗑️</button></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Prizes -->
      <div v-if="dtab==='prizes'" class="st-section" style="padding:14px;">
        <div class="d-flex gap-2 mb-3 flex-wrap align-items-end">
          <input class="st-input" v-model="prizeForm.category" placeholder="e.g. 100m Sprint" style="width:140px;" />
          <select class="st-input" v-model.number="prizeForm.position" style="width:80px;padding:7px;"><option :value="1">1st</option><option :value="2">2nd</option><option :value="3">3rd</option></select>
          <input class="st-input" v-model="prizeForm.winnerName" placeholder="Winner name" style="width:140px;" />
          <input class="st-input" v-model="prizeForm.prize" placeholder="e.g. Trophy" style="width:120px;" />
          <button class="btn st-btn-primary btn-sm" @click="addPrize" :disabled="!prizeForm.category">+ Add</button>
        </div>
        <table v-if="detail?.prizes?.length" class="la-table">
          <thead><tr><th>Category</th><th>Position</th><th>Winner</th><th>Prize</th><th></th></tr></thead>
          <tbody>
            <tr v-for="p in detail.prizes" :key="p.id">
              <td>{{ p.category }}</td><td>{{ ['','🥇','🥈','🥉'][p.position] || p.position }}</td>
              <td style="color:#F59E0B;font-weight:600;">{{ p.student_name || p.winner_name || '—' }}</td>
              <td>{{ p.prize_description || '—' }}</td>
              <td><button class="btn st-btn-outline btn-sm" style="padding:1px 6px;font-size:10px;color:#EF4444;" @click="deletePrize(p)">🗑️</button></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Event Form Modal -->
    <div v-if="showEventForm" class="la-overlay" @click.self="showEventForm=false">
      <div class="la-modal">
        <h5 style="color:#E8EDF4;margin:0 0 16px;font-size:15px;">{{ evtForm.id ? 'Edit' : 'Create' }} Event</h5>
        <div class="mb-2"><label class="st-label" style="font-size:10px;">Name *</label><input class="st-input" v-model="evtForm.name" placeholder="e.g. Sports Day 2026" /></div>
        <div class="mb-2"><label class="st-label" style="font-size:10px;">Description</label><textarea class="st-input" v-model="evtForm.description" rows="2" placeholder="Event details..."></textarea></div>
        <div class="row g-2 mb-2">
          <div class="col-6"><label class="st-label" style="font-size:10px;">Venue</label><input class="st-input" v-model="evtForm.venue" placeholder="e.g. School Field" /></div>
          <div class="col-6"><label class="st-label" style="font-size:10px;">Date *</label><input class="st-input" type="date" v-model="evtForm.eventDate" /></div>
        </div>
        <div class="row g-2 mb-2">
          <div class="col-4"><label class="st-label" style="font-size:10px;">Start Time</label><input class="st-input" type="time" v-model="evtForm.startTime" /></div>
          <div class="col-4"><label class="st-label" style="font-size:10px;">End Time</label><input class="st-input" type="time" v-model="evtForm.endTime" /></div>
          <div class="col-4"><label class="st-label" style="font-size:10px;">Price/Student</label><input class="st-input" type="number" v-model.number="evtForm.price" placeholder="0" /></div>
        </div>
        <div class="row g-2 mb-3">
          <div class="col-6"><label class="st-label" style="font-size:10px;">Capacity</label><input class="st-input" type="number" v-model.number="evtForm.capacity" placeholder="0 = unlimited" /></div>
          <div class="col-6" style="display:flex;align-items:flex-end;"><label style="font-size:12px;color:#8BA4C4;cursor:pointer;display:flex;align-items:center;gap:6px;"><input type="checkbox" v-model="evtForm.isMandatory" /> Mandatory for all students</label></div>
        </div>
        <div class="d-flex gap-2 justify-content-end">
          <button class="btn st-btn-outline btn-sm" @click="showEventForm=false">Cancel</button>
          <button class="btn st-btn-primary btn-sm" @click="saveEvent" :disabled="evtSaving">Save Event</button>
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
/* eslint-disable */
import Navigation from "@/components/simi-auth/Navigation.vue";
import { executeJson, simitrack } from "@/api";
export default {
  name: 'EventsManager',
  components: { Navigation },
  data() {
    return {
      events: [], evtLoading: false, statusFilter: '',
      selectedEvent: null, detail: null, dtab: 'attendance',
      showEventForm: false, evtSaving: false,
      evtForm: { id:'', name:'', description:'', venue:'', eventDate:'', startTime:'', endTime:'', price:0, capacity:0, isMandatory:false },
      // Attendance
      attSearch: '', attSearchResults: [],
      // Payments
      paySearch: '', paySearchResults: [], payMethod: 'cash', payAmount: 0,
      // Expenses
      expCategories: ['venue','transport','catering','equipment','prizes','decorations','marketing','other'],
      expForm: { category:'other', description:'', amount:0, paidTo:'' },
      // Prizes
      prizeForm: { category:'', position:1, winnerName:'', prize:'' },
      searchTimer: null,
    };
  },
  mounted() { this.loadEvents(); },
  methods: {
    async loadEvents() {
      this.evtLoading = true;
      try { const r = await executeJson({ function: 'getEvents', status: this.statusFilter }, simitrack); if (r.data.success) this.events = r.data.data || []; } catch(e) {}
      this.evtLoading = false;
    },
    async openEvent(e) {
      this.selectedEvent = e; this.dtab = 'attendance'; this.detail = null;
      try { const r = await executeJson({ function: 'getEventDetail', eventId: e.id }, simitrack); if (r.data.success) this.detail = r.data.data; } catch(e) {}
    },
    async reloadDetail() { if (this.selectedEvent) await this.openEvent(this.selectedEvent); },
    openEventForm(e) {
      if (e) { this.evtForm = { id:e.id, name:e.name, description:e.description||'', venue:e.venue||'', eventDate:e.event_date, startTime:e.start_time?.substring(0,5)||'', endTime:e.end_time?.substring(0,5)||'', price:e.price_per_student||0, capacity:e.capacity||0, isMandatory:e.is_mandatory==1 }; }
      else { this.evtForm = { id:'', name:'', description:'', venue:'', eventDate:'', startTime:'', endTime:'', price:0, capacity:0, isMandatory:false }; }
      this.showEventForm = true;
    },
    async saveEvent() {
      this.evtSaving = true;
      try {
        const res = await executeJson({ function: 'saveEvent', ...this.evtForm }, simitrack);
        if (res.data.success) { this.showEventForm = false; this.loadEvents(); if (this.selectedEvent && this.evtForm.id) this.reloadDetail(); }
        else alert(res.data.message);
      } catch(e) { alert('Error'); }
      this.evtSaving = false;
    },
    async updateEventStatus() {
      try { await executeJson({ function: 'saveEvent', id: this.selectedEvent.id, name: this.selectedEvent.name, eventDate: this.selectedEvent.event_date, status: this.selectedEvent.status }, simitrack); } catch(e) {}
    },
    searchStudentsForEvent() {
      clearTimeout(this.searchTimer);
      const q = this.attSearch || this.paySearch;
      this.searchTimer = setTimeout(async () => {
        if (!q || q.length < 2) { this.attSearchResults = []; this.paySearchResults = []; return; }
        try {
          const r = await executeJson({ function: 'searchStudentsForMatch', query: q }, simitrack);
          if (r.data.success) { this.attSearchResults = r.data.data || []; this.paySearchResults = r.data.data || []; }
        } catch(e) {}
      }, 300);
    },
    async markEventAttendance(s) {
      try { await executeJson({ function: 'markEventAttendance', eventId: this.selectedEvent.id, studentId: s.id }, simitrack); this.attSearch = ''; this.attSearchResults = []; this.reloadDetail(); } catch(e) {}
    },
    async recordPayment(s) {
      const amt = this.payAmount || this.selectedEvent.price_per_student || 0;
      try { await executeJson({ function: 'recordEventPayment', eventId: this.selectedEvent.id, studentId: s.id, amount: amt, paymentMethod: this.payMethod }, simitrack); this.paySearch = ''; this.paySearchResults = []; this.reloadDetail(); } catch(e) {}
    },
    async addExpense() {
      try { await executeJson({ function: 'addEventExpense', eventId: this.selectedEvent.id, ...this.expForm }, simitrack); this.expForm = { category:'other', description:'', amount:0, paidTo:'' }; this.reloadDetail(); } catch(e) {}
    },
    async deleteExpense(e) { if (!confirm('Delete this expense?')) return; try { await executeJson({ function: 'deleteEventExpense', id: e.id }, simitrack); this.reloadDetail(); } catch(e) {} },
    async addPrize() {
      try { await executeJson({ function: 'addEventPrize', eventId: this.selectedEvent.id, ...this.prizeForm }, simitrack); this.prizeForm = { category:'', position:1, winnerName:'', prize:'' }; this.reloadDetail(); } catch(e) {}
    },
    async deletePrize(p) { if (!confirm('Delete this prize?')) return; try { await executeJson({ function: 'deleteEventPrize', id: p.id }, simitrack); this.reloadDetail(); } catch(e) {} },
  }
};
</script>

<style scoped>
.st-page{min-height:100vh;background:#0A1628;padding-top:70px;}.st-back{color:#8BA4C4;font-size:22px;text-decoration:none;}.st-back:hover{color:#4FC3F7;}.st-page-title{color:#E8EDF4;font-size:18px;font-weight:700;margin:0;}
.st-section{background:#0F2347;border:1px solid #1A3A6A;border-radius:14px;padding:20px;margin-bottom:16px;}.st-label{color:#8BA4C4;font-size:12px;font-weight:600;margin-bottom:4px;display:block;}
.st-input{width:100%;background:#0A1628;border:1px solid #1A3A6A;border-radius:8px;padding:8px 12px;color:#E8EDF4;font-size:13px;outline:none;}.st-input:focus{border-color:#2E86DE;}
.st-btn-primary{background:linear-gradient(135deg,#2E86DE,#1A6BC4);color:#fff;border:none;font-weight:600;border-radius:8px;padding:8px 16px;font-size:13px;}.st-btn-outline{background:transparent;border:1px solid #1A3A6A;color:#8BA4C4;font-weight:600;border-radius:8px;padding:8px 16px;font-size:13px;}.st-btn-outline:hover{border-color:#4FC3F7;color:#4FC3F7;}
.st-spinner{display:flex;justify-content:center;padding:30px;}.st-spinner .spinner-border{color:#2E86DE;}
.la-tabs{display:flex;gap:4px;margin-bottom:16px;border-bottom:2px solid #1A3A6A;}.la-tab{background:none;border:none;padding:10px 16px;color:#4A6A8A;font-size:13px;font-weight:600;cursor:pointer;border-bottom:2px solid transparent;margin-bottom:-2px;}.la-tab.active{color:#4FC3F7;border-bottom-color:#4FC3F7;}
.la-table{width:100%;border-collapse:collapse;font-size:12px;color:#E8EDF4;}.la-table th{background:#0A1628;padding:6px 8px;color:#4FC3F7;font-size:10px;text-transform:uppercase;border-bottom:2px solid #1A3A6A;}.la-table td{padding:5px 8px;border-bottom:1px solid #1A3A6A;}
.la-overlay{position:fixed;top:0;left:0;right:0;bottom:0;background:rgba(0,0,0,.7);display:flex;align-items:center;justify-content:center;z-index:999;}
.la-modal{background:#0D2B5E;border-radius:14px;padding:24px;width:95%;max-width:520px;max-height:85vh;overflow-y:auto;border:1px solid #1A3A6A;}
.ev-card{background:#0F2347;border:1px solid #1A3A6A;border-radius:12px;padding:16px;margin-bottom:10px;cursor:pointer;transition:.2s;}.ev-card:hover{border-color:#4FC3F7;}
.ev-name{font-size:16px;font-weight:700;color:#E8EDF4;}.ev-meta{font-size:12px;color:#8BA4C4;margin-top:2px;}
.ev-stats{display:flex;gap:16px;flex-wrap:wrap;font-size:11px;color:#8BA4C4;margin-top:8px;padding-top:8px;border-top:1px solid #1A3A6A;}
.ev-status{display:inline-block;padding:2px 8px;border-radius:4px;font-size:10px;font-weight:600;text-transform:capitalize;}
.ev-upcoming{background:rgba(79,195,247,.15);color:#4FC3F7;}.ev-ongoing{background:rgba(16,185,129,.15);color:#10B981;}.ev-completed{background:rgba(139,92,246,.15);color:#8B5CF6;}.ev-cancelled{background:rgba(239,68,68,.15);color:#EF4444;}
.ev-pl-row{display:grid;grid-template-columns:repeat(auto-fit,minmax(120px,1fr));gap:10px;margin-top:12px;}.ev-pl-box{background:#0A1628;border:1px solid #1A3A6A;border-radius:8px;padding:10px;text-align:center;}.ev-pl-label{font-size:10px;color:#4A6A8A;text-transform:uppercase;font-weight:600;}.ev-pl-value{font-size:18px;font-weight:800;}
</style>
